import SalesPointView from "../SalesPointView.vue";
import SalesPointsList from "../Pages/SalesPointsList.vue";
import SalesPointEditor from "../Pages/SalesPointEditor.vue";
import SalesPointUpload from "../Pages/SalesPointUpload.vue";

const routes = [
  {
    path: 'puntos-de-venta',
    component: SalesPointView,
    children: [
      {
        path: '',
        name: 'celulares-sales-points-list',
        roles: ['pdv_lista'],
        component: SalesPointsList
      },
      {
        path: 'crear',
        name: 'celulares-sales-points-create',
        roles: ['pdv_lista_agregar'],
        component: SalesPointEditor
      },
      {
        path: ':id/editar',
        name: 'celulares-sales-points-edit',
        roles: ['pdv_lista_editar'],
        component: SalesPointEditor
      },
      {
        path: 'carga',
        name: 'celulares-sales-points-upload',
        roles: ['pdv_carga_masiva'],
        component: SalesPointUpload
      }
    ]
  },
]

export default routes
